import { createLocalExpirableStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

export const NOT_ENROLLED = 'not-enrolled';
export const VARIATION = 'variation';

export const WHITEBOARDS_EXPAND_JIRAS_EXPERIMENT = 'grw_1037_expand_plan_in_whiteboards';

export const CTA_SOURCE_CONTEXT = 'planOnWhiteboardBacklogButton';
export const CTA_SOURCE_COMPONENT = 'planOnWhiteboardsButtonCTAScreen';

export const CTA_SPOTLIGHT_SOURCE_CONTEXT = 'planOnWhiteboardSpotlightButton';

export type Flow = 'none' | 'crossFlow' | 'coUse' | 'crossJoin';

export const DATA_PRIVACY_LINK = 'https://www.atlassian.com/legal/privacy-policy';

export const WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS = {
	CONTEXT_MENU: 'variant_contextual_menu',
	BACKLOG_BUTTON: 'variant_backlog_button',
	CONTROL: 'control',
} as const;

export type WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS =
	(typeof WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS)[keyof typeof WHITEBOARD_ENTRYPOINT_EXPERIMENT_VARIANTS];

export type Key = {
	key: string;
	self: string;
};

export type UserPropertyKeys = {
	keys: Key[];
};

export const USER_PROPERTY_KEY_NAMES = {
	BANNER_DISMISSED: 'whiteboards-backlog-entrypoint-banner-dismissed',
	WHITEBOARDS_BACKLOG_ENTRYPOINT_DISMISSED: 'whiteboards-backlog-entrypoint-dismissed',
} as const;

export type UserPropertyKeyNames =
	(typeof USER_PROPERTY_KEY_NAMES)[keyof typeof USER_PROPERTY_KEY_NAMES];

export const ELEMENT_IDS = {
	CTA_BUTTON:
		'software-backlog.whiteboards-entrypoint-experiment.backlog-button-refresh.cta-button',
	BANNER:
		'software-backlog.whiteboards-entrypoint-experiment.backlog-button-refresh.banner-container',
	TOUCHPOINT:
		'software-backlog.whiteboards-entrypoint-experiment.backlog-button-refresh.whiteboards-touchpoint',
} as const;

export const CACHE_KEYS = {
	HAS_XFLOW_FROM_WHITEBOARDS_TOUCHPOINT_TAP_TRAIT_KEY:
		'whiteboard_backlog_jira_ui_button_clicked_confirmbutton_xflow',
	USER_PROPERTIES: 'whiteboard_backlog_jira_ui_user_properties',
	PULSE_LOCAL_STORAGE_KEY: 'whiteboardsExperimentHasClickedOnPulse',
	WHITEBOARDS_ENTRYPOINT_CONFLUENCE_DATA_KEY: 'whiteboards_backlog_jira_confluence_data',
} as const;

export const STORAGE_PROVIDER_PREFIX = 'whiteboards-entrypoint';

const whiteboardsLocalStorage = createLocalExpirableStorageProvider('whiteboardsTouchpoint');

const TEN_SECONDS = 10 * 1000;

export const setHasClickedOnPulse = () =>
	whiteboardsLocalStorage.set(CACHE_KEYS.PULSE_LOCAL_STORAGE_KEY, 'true');

export const getHasClickedOnPulse = (): boolean =>
	whiteboardsLocalStorage.get(CACHE_KEYS.PULSE_LOCAL_STORAGE_KEY) === 'true';

export const getConfluenceData = () =>
	whiteboardsLocalStorage.get(CACHE_KEYS.WHITEBOARDS_ENTRYPOINT_CONFLUENCE_DATA_KEY);

export const setConfluenceData = (data: {
	hasConfluenceRequestOrDirectAccess: boolean;
	hasConfluenceAccess: boolean;
	hasConfluenceSpaces: boolean;
}) =>
	whiteboardsLocalStorage.set(
		CACHE_KEYS.WHITEBOARDS_ENTRYPOINT_CONFLUENCE_DATA_KEY,
		data,
		Date.now() + TEN_SECONDS,
	);
